import React from 'react';
import Container from 'Nori/Container';
import styles from 'Custom/ISI/ISI.module.scss';
import RichText from 'Custom/RichText';
import Link from 'next/link';
import { useAppContext } from 'Providers/App';
import { ISI_CONTENT } from 'Custom/ISI/ISI.utils';
import { UI_ELEMENTS } from 'Providers/App/elements';

const { modalExternalLink: modalExternalLinkId } = UI_ELEMENTS;

const ISI = ({
  isModal = false,
  noriId = '',
  moduleTitle = '',
  content = ISI_CONTENT,
  ...props
}) => {
  const { setExternalUrl, getElementClickHandler } = useAppContext();
  const { INDICATION_SHORT_BLOCK, CONTENT_BLOCK, ISI_REPORT } = content;

  const modalExternalLinkHandler = getElementClickHandler(modalExternalLinkId);

  return (
    <Container
      className={`${styles.wrapper} ISI_wrapper`}
      {...props}
      data-qa-tag="isi-wrapper"
    >
      {!isModal && (
        <RichText data-qa-tag="isi-indication-content">
          {INDICATION_SHORT_BLOCK}
        </RichText>
      )}
      <div className={styles.topBlock} data-qa-tag="isi-topBlock">
        <RichText data-qa-tag="isi-content-block">{CONTENT_BLOCK}</RichText>
      </div>

      <RichText data-qa-tag="isi-report">
        <p className={styles.reportFda} data-qa-tag="isi-report-content">
          {ISI_REPORT.firstPart}{' '}
          <button
            data-design-type="clickAction"
            data-design-category="content_link_vd"
            data-design-action="Link"
            data-design-label="www.fda.gov/medwatch"
            data-design-nori_id={noriId}
            data-design-module_name={moduleTitle}
            data-design-module_no="00"
            data-qa-tag="fda-medwatch-link-button"
            onClick={(event) => {
              modalExternalLinkHandler(event);
              setExternalUrl(
                'https://www.fda.gov/safety/medwatch-fda-safety-information-and-adverse-event-reporting-program'
              );
            }}
            className={styles.poplink}
          >
            www.fda.gov/medwatch
          </button>{' '}
          {ISI_REPORT.secondPart}{' '}
          <Link
            data-design-type="clickAction"
            data-design-category="content_link_vd"
            data-design-action="Link"
            data-design-label="1-800-FDA-1088."
            data-design-nori_id={noriId}
            data-design-module_name={moduleTitle}
            data-design-module_no="00"
            className={styles.phoneLink}
            data-qa-tag="fda-link-phone-number"
            href="tel:18003321088"
          >
            1-800-FDA-1088.
          </Link>
        </p>
        <ISI_REPORT.Accompanying
          moduleTitle={moduleTitle}
          noriId={noriId}
          data-qa-tag="isi-report-bottom-note"
        />
      </RichText>
    </Container>
  );
};

export default ISI;
